/* Solicitudes (Hostelking) — envío AJAX de los formularios de "bajo pedido" y "avísame cuando haya stock".
   Intercepta cualquier <form data-solicitud>, hace POST al endpoint de captura y muestra el éxito inline.
   Sin recarga de página. Un solo listener delegado (seguro aunque el snippet se incluya dos veces). */
(function () {
  if (window.__solicitudesInit) return;
  window.__solicitudesInit = true;

  var ENDPOINT = 'https://e09olrymsl.execute-api.eu-west-1.amazonaws.com/production/captura';

  function post(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) { params.append(key, value); });
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; });
    });
  }

  // Cambio de variante en la ficha (evento del tema, variant-picker.js): los formularios llevan la variante
  // ELEGIDA, no la de carga (fallo abierto del 2-oct-2026), y el aviso de pedido mínimo cambia con ella.
  document.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    document.querySelectorAll('form[data-solicitud]').forEach(function (form) {
      var sku = form.querySelector('input[name="sku"]');
      var vid = form.querySelector('input[name="variante_id"]');
      if (sku && v.sku) sku.value = v.sku;
      if (vid) vid.value = 'gid://shopify/ProductVariant/' + v.id;
      var msg = form.querySelector('textarea[name="mensaje"]');
      if (msg && sku && /^Quiero encargar: .*\([^)]*\)\. ?$/.test(msg.value)) msg.value = msg.value.replace(/\([^)]*\)/, '(' + (v.sku || '') + ')');
      var min = form.querySelector('.bajo-pedido__min');
      if (min) {
        var tabla = {};
        (min.dataset.minimos || '').split(',').forEach(function (par) { var a = par.split(':'); if (a[0]) tabla[a[0]] = a[1]; });
        var n = tabla[String(v.id)];
        min.hidden = !n;
        if (n) {
          min.querySelector('[data-min-valor]').textContent = n;
          min.querySelector('[data-min-unidad]').textContent = Number(n) === 1 ? 'caja' : 'cajas';
        }
      }
    });
  });

  // Botón "Avísame" (sin sesión): despliega el campo de email y oculta el botón.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest ? e.target.closest('[data-aviso-toggle]') : null;
    if (!toggle) return;
    var form = toggle.closest('form[data-solicitud]');
    if (!form) return;
    var panel = form.querySelector('[data-aviso-panel]');
    if (panel) panel.hidden = false;
    toggle.hidden = true;
    var email = form.querySelector('input[type="email"]');
    if (email) email.focus();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-solicitud]')) return;
    e.preventDefault();

    var fields = form.querySelector('[data-fields]');
    var okEl = form.querySelector('[data-ok]');
    var errEl = form.querySelector('[data-err]');
    var btn = form.querySelector('[type="submit"]');
    if (errEl) errEl.hidden = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    post(form).then(function (res) {
      if (res.status === 200 && res.body && res.body.ok) {
        if (fields) fields.hidden = true;
        if (okEl) okEl.hidden = false;
      } else {
        var msg = (res.body && res.body.errors && res.body.errors.join('. ')) ||
                  'No se pudo enviar. Inténtalo de nuevo en un momento.';
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      }
    }).catch(function () {
      if (errEl) { errEl.textContent = 'Error de conexión. Inténtalo de nuevo.'; errEl.hidden = false; }
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
  });

  // ── Mini-carrusel de productos relacionados (cuando sale "avísame") ──
  function money(cents) {
    return (Number(cents) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  // Rueda del ratón sobre el carrusel -> desplazamiento horizontal (deja pasar en los extremos).
  // NO se toca el puntero ni el clic: el track ya es un overflow-x nativo, así que se desplaza con
  // la barra, con el trackpad y con la rueda, y los enlaces de las tarjetas quedan intactos.
  // Hubo aquí un "arrastrar para desplazar" que cancelaba el clic si el puntero se movía; con un
  // ratón real eso impedía abrir el producto. No reintroducirlo sin resolver ese caso.
  function enableWheelScroll(el) {
    el.addEventListener('wheel', function (e) {
      if (el.scrollWidth <= el.clientWidth) return;
      var d = e.deltaY;
      if (!d) return;
      var atStart = el.scrollLeft <= 0;
      var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
      if ((d < 0 && atStart) || (d > 0 && atEnd)) return;
      el.scrollLeft += d;
      e.preventDefault();
    }, { passive: false });
  }

  // Precio con la MISMA estructura del tema (.price__default/.price__current/.price__was) para que
  // el sistema IVA de la web lo procese igual que las cards: modo activo primero + el otro debajo,
  // y siguiendo el toggle con/sin IVA. Valores CON IVA (el sistema deriva el sin IVA ÷1,21).
  function priceHtml(price, compare) {
    var was = (compare && compare > price) ? '<s class="price__was">' + money(compare) + '</s>' : '';
    return '<strong class="price__current">' + money(price) + '</strong>' + was;
  }

  function initRelated() {
    var box = document.querySelector('[data-related-for]');
    if (!box) return;
    var pid = box.getAttribute('data-related-for');
    fetch('/recommendations/products.json?product_id=' + pid + '&intent=related&limit=12')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).filter(function (p) { return p.available && String(p.id) !== String(pid); });
        if (!prods.length) return;
        var cards = prods.map(function (p) {
          return '<a class="aviso-related__card" href="' + p.url + '">' +
            '<img class="aviso-related__img" src="' + imgUrl(p.featured_image, 300) + '" alt="" loading="lazy">' +
            '<span class="aviso-related__title">' + esc(p.title) + '</span>' +
            '<div class="price__default aviso-related__price theme-money">' + priceHtml(p.price, p.compare_at_price) + '</div>' +
            '</a>';
        }).join('');
        box.innerHTML = '<div class="aviso-related__head">Alternativas disponibles</div>' +
          '<div class="aviso-related__wrap">' +
            '<button type="button" class="aviso-related__nav aviso-related__nav--prev" aria-label="Ver anteriores">\u2039</button>' +
            '<div class="aviso-related__track">' + cards + '</div>' +
            '<button type="button" class="aviso-related__nav aviso-related__nav--next" aria-label="Ver siguientes">\u203A</button>' +
          '</div>' +
          '<div class="aviso-related__bar"><span class="aviso-related__bar-thumb"></span></div>';
        var track = box.querySelector('.aviso-related__track');
        var bar = box.querySelector('.aviso-related__bar');
        var thumb = box.querySelector('.aviso-related__bar-thumb');
        var prev = box.querySelector('.aviso-related__nav--prev');
        var next = box.querySelector('.aviso-related__nav--next');
        if (track) {
          enableWheelScroll(track);

          // Flechas: la barra nativa está oculta por CSS y ya no hay arrastre, así que son
          // la única forma visible de recorrer el carrusel con ratón. No tocan el clic de
          // las tarjetas: solo desplazan el contenedor.
          // OJO: scrollBy/scrollTo con behavior:'smooth' no mueve nada en algunos navegadores;
          // se comprobó en vivo. Se asigna scrollLeft directamente, que funciona siempre.
          // No reintroducir el desplazamiento suave sin comprobarlo en el navegador real.
          var paso = function () { return Math.max(160, Math.round(track.clientWidth * 0.8)); };
          var mover = function (signo) {
            return function () {
              var max = track.scrollWidth - track.clientWidth;
              var destino = track.scrollLeft + signo * paso();
              track.scrollLeft = Math.max(0, Math.min(max, destino));
              updateBar(); // el evento 'scroll' llega tarde; refrescamos flechas y barra ya
            };
          };
          prev.addEventListener('click', mover(-1));
          next.addEventListener('click', mover(1));

          function updateBar() {
            var overflow = track.scrollWidth - track.clientWidth;
            var hayDesbordamiento = overflow > 2;
            bar.style.display = hayDesbordamiento ? '' : 'none';
            prev.style.display = hayDesbordamiento && track.scrollLeft > 2 ? '' : 'none';
            next.style.display = hayDesbordamiento && track.scrollLeft < overflow - 2 ? '' : 'none';
            var w = Math.max(15, (track.clientWidth / track.scrollWidth) * 100);
            var pos = overflow > 0 ? (track.scrollLeft / overflow) : 0;
            thumb.style.width = w + '%';
            thumb.style.left = (pos * (100 - w)) + '%';
          }
          track.addEventListener('scroll', updateBar);
          window.addEventListener('resize', updateBar);
          updateBar();
        }
      })
      .catch(function () {});
  }
  initRelated();
})();
